//* ↓↓ LIST OF APIs ↓↓
const PROD_API = 'https://api.soroban.ua/panel';

export { PROD_API };
